var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconAct(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "IconAct"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.33398 4.00033C1.33398 2.31312 2.63273 0.666992 4.56475 0.666992H9.55508C10.3439 0.666992 11.101 0.977687 11.6624 1.53181L13.7747 3.61654C14.3458 4.18023 14.6673 4.94925 14.6673 5.75172V12.0003C14.6673 13.6875 13.3686 15.3337 11.4365 15.3337H4.56475C2.63273 15.3337 1.33398 13.6875 1.33398 12.0003V4.00033ZM5.16732 6.00033C4.89118 6.00033 4.66732 6.22418 4.66732 6.50033V6.83366C4.66732 7.1098 4.89118 7.33366 5.16732 7.33366H8.83398C9.11013 7.33366 9.33398 7.1098 9.33398 6.83366V6.50033C9.33398 6.22418 9.11013 6.00033 8.83398 6.00033H5.16732ZM7.33398 9.16699C7.33398 8.89085 7.11013 8.66699 6.83398 8.66699H5.16732C4.89118 8.66699 4.66732 8.89085 4.66732 9.16699V9.50032C4.66732 9.77647 4.89118 10.0003 5.16732 10.0003H5.58658C5.48631 9.85053 5.4123 9.68167 5.37115 9.50032C5.35879 9.44584 5.34939 9.39022 5.34314 9.33366H6.65816C6.65191 9.39022 6.64251 9.44584 6.63015 9.50032C6.589 9.68167 6.515 9.85053 6.41473 10.0003H6.83398C7.11013 10.0003 7.33398 9.77647 7.33398 9.50033V9.16699ZM3.33398 12.0003C3.33398 12.7367 3.88502 13.3337 4.56475 13.3337H11.4365C12.1163 13.3337 12.6673 12.7367 12.6673 12.0003V5.75172C12.6673 5.48423 12.5602 5.22789 12.3698 5.03999L10.2575 2.95527C10.0704 2.77056 9.81802 2.66699 9.55508 2.66699H4.56475C3.88502 2.66699 3.33398 3.26395 3.33398 4.00033V12.0003Z",
    fill: "#002CFB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 59 (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.829 9.49473C11.9462 9.61189 11.9462 9.80184 11.829 9.919L9.89975 11.8483C9.7826 11.9654 9.59265 11.9654 9.47549 11.8483L8.21287 10.5857C8.09571 10.4685 8.09571 10.2786 8.21287 10.1614L8.49571 9.87856C8.61287 9.7614 8.80282 9.7614 8.91998 9.87856L9.68762 10.6462L11.1219 9.21189C11.2391 9.09473 11.429 9.09473 11.5462 9.21189L11.829 9.49473Z",
    fill: "#002CFB"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAct);
export default __webpack_public_path__ + "static/media/iconAct.39001670619a5c05e96937f38fb7a7e6.svg";
export { ForwardRef as ReactComponent };